export default "__VITE_ASSET__BZ5fgezt__"